import { ReactComponent as InfoIcon } from '@pages/collectionAdministration/pages/NewEditTemplateCollection/components/NewEditTemplateCollectionBody/components/NewEditTemplateCollectionBodyOptions/assets/infoTooltipIcon.svg'
import CustomModal from "@UI/CustomModal"
import CustomPopoverConfirm from "@UI/CustomPopoverConfirm"
import { Button } from "antd"
import PropTypes from "prop-types"
import './styles.css'
import { useUpdateAmountModal } from './hooks/useUpdateAmountModal'
import { CustomInput } from '@UI/CustomInput'
import { CustomSpin } from '@UI/CustomSpin'

const UpdateAmountModal = ({
  isOpen,
  onClose,
  record
}) => {
  const {
    handleSaveUpdateAmount,
    handleDetailChange,
    handleTaxChange,
    handleTotalsChange,
    handleCloseModal,
    newDebtorPaymentDetailData,
    loadingReceivedPaymentDetail,
    currencySymbol,
    debtorPaymentDetailData
  } = useUpdateAmountModal({ isOpen, handleOpenCloseModal: onClose, record })

  return (
    <CustomModal
      destroyOnClose={true}
      className="custom-modal check-users-modal"
      isOpenModal={isOpen}
      footer={<div className="users-modal-form-footer">
        <Button
          className="btn-standard-green"
          htmlType="buttom"
          shape="round"
          style={{ width: 'fit-content' }}
          loading={loadingReceivedPaymentDetail}
          onClick={() => handleSaveUpdateAmount()}
        >
          GUARDAR CAMBIOS
        </Button>
      </div>}
      onCancel={() => {
        handleCloseModal()
      }}
      width={620}
    >
      <div className="recurrency-modal-title">
        <span>Editar monto</span>
        <CustomPopoverConfirm
          placement={'bottom'}
          overlayClassName={'info-tooltip-popover'}
          content={<div className="info-tooltip-popover-content">
            <p>TEXTO FALTANTE:</p>
          </div>}
          maxWidth={325}
        >
          <Button
            icon={<InfoIcon />}
            className="btn-standard-transparent"
            shape="circle"
            style={{ marginLeft: '8px', width: '32px' }}
          />
        </CustomPopoverConfirm>
      </div>
      <CustomSpin spinning={loadingReceivedPaymentDetail} >
        <div className="users-modal-body">
          <div className="update-amount-modal-table">
            <div className="update-amount-modal-table-body">
              <div className="update-amount-modal-table-body-item">
                <span className="update-amount-modal-table-body-item-place">Detalle</span>
                <span className="update-amount-modal-table-body-item-name">Monto actual</span>
                <span className="update-amount-modal-table-body-item-new-amount">Monto nuevo</span>
              </div>
              {
                debtorPaymentDetailData?.details?.map((item, index) => ({ ...item, key: index })).map((item) => (
                  <div className="update-amount-modal-table-body-item" key={item?.key}>
                    <span className="update-amount-modal-table-body-item-place">{item?.name || '---'}</span>
                    <span className="update-amount-modal-table-body-item-name">{currencySymbol} {(item?.total ?? 0)?.toFixed(2)}</span>
                    <span className="update-amount-modal-table-body-item-new-amount">
                      <CustomInput
                        prefix={currencySymbol}
                        type='NUMBER'
                        min={0}
                        precision={2}
                        step={0.01}
                        nullInputNumberText=''
                        value={(newDebtorPaymentDetailData?.details?.[item.key]?.total ?? 0)?.toFixed(2)}
                        onChange={(e) => handleDetailChange(item.key, e)}
                      />
                    </span>
                  </div>
                ))
              }
              <div style={{ width: '100%', backgroundColor: '#E9E9E9', minHeight: '2px' }} />
              {
                debtorPaymentDetailData?.taxes?.map((item, index) => ({ ...item, key: index })).map((item) => (
                  <div className="update-amount-modal-table-body-item" key={item?.key}>
                    <span className="update-amount-modal-table-body-item-place">{item?.name || '---'}</span>
                    <span className="update-amount-modal-table-body-item-name">{currencySymbol} {(item?.total ?? 0)?.toFixed(2)}</span>
                    <span className="update-amount-modal-table-body-item-new-amount">
                      <CustomInput
                        prefix={currencySymbol}
                        type='NUMBER'
                        min={0}
                        precision={2}
                        step={0.01}
                        nullInputNumberText=''
                        value={(newDebtorPaymentDetailData?.taxes?.[item.key]?.total ?? 0).toFixed(2)}
                        onChange={(e) => handleTaxChange(item.key, e)}
                      />
                    </span>
                  </div>
                ))
              }
              <div style={{ width: '100%', backgroundColor: '#E9E9E9', minHeight: '2px', margin: '4px 0' }} />
              <div className="update-amount-modal-table-body-item">
                <span className="update-amount-modal-table-body-item-place">{'Monto gravable'}</span>
                <span className="update-amount-modal-table-body-item-name">{currencySymbol} {(debtorPaymentDetailData?.totals?.tax_total ?? 0)?.toFixed(2)}</span>
                <span className="update-amount-modal-table-body-item-new-amount">
                  <CustomInput
                    prefix={currencySymbol}
                    min={0}
                    precision={2}
                    step={0.01}
                    type='NUMBER'
                    nullInputNumberText=''
                    value={(newDebtorPaymentDetailData?.totals?.tax_total ?? 0).toFixed(2)}
                    onChange={(e) => handleTotalsChange('tax_total', e)}
                  />
                </span>
              </div>
              <div className="update-amount-modal-table-body-item">
                <span className="update-amount-modal-table-body-item-place">{'Total de impuestos'}</span>
                <span className="update-amount-modal-table-body-item-name">{currencySymbol} {(debtorPaymentDetailData?.totals?.taxable_total ?? 0)?.toFixed(2)}</span>
                <span className="update-amount-modal-table-body-item-new-amount">
                  <CustomInput
                    prefix={currencySymbol}
                    min={0}
                    precision={2}
                    step={0.01}
                    type='NUMBER'
                    nullInputNumberText=''
                    value={newDebtorPaymentDetailData?.totals?.taxable_total?.toFixed(2)}
                    onChange={(e) => handleTotalsChange('taxable_total', e)}
                  />
                </span>
              </div>
              <div className="update-amount-modal-table-body-item">
                <span className="update-amount-modal-table-body-item-place">{'Total'}</span>
                <span className="update-amount-modal-table-body-item-name">{currencySymbol} {(debtorPaymentDetailData?.totals?.total ?? 0)?.toFixed(2)}</span>
                <span className="update-amount-modal-table-body-item-new-amount">
                  <CustomInput
                    prefix={currencySymbol}
                    min={0}
                    precision={2}
                    step={0.01}
                    type='NUMBER'
                    nullInputNumberText=''
                    value={newDebtorPaymentDetailData?.totals?.total?.toFixed(2)}
                    onChange={(e) => handleTotalsChange('total', e)}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </CustomSpin>
    </CustomModal>
  )
}

UpdateAmountModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  record: PropTypes.object.isRequired
}


export default UpdateAmountModal
